import { Globe, type LucideIcon } from 'lucide-react'

export interface Language {
  code: 'en' | 'bg'
  labelKey: 'language.en' | 'language.bg'
  icon: LucideIcon
}

export const languages: Language[] = [
  { code: 'en', labelKey: 'language.en', icon: Globe },
  { code: 'bg', labelKey: 'language.bg', icon: Globe },
]
